import { styled } from 'goober';
import { Typography } from '@shared/ui/typography/typography';
import { COLORS } from '@shared/config/colors/colors';
import { baseShadowStyle } from '@shared/style/base-shadow';
import { LinkScroll } from '@shared/ui/link-scroll/link-scroll';

export const Controls = styled('div')`
    display: flex;
    gap: 12px;
    height: fit-content;
    visibility: hidden;
    opacity: 0;
    transition: 0.3s opacity;
`;

export const Title = styled('div')`
    display: flex;
    align-items: center;
    gap: 8px;

    & > :first-child {
        transition: 0.3s color;
    }
`;

export const Name = styled(Typography)`
    word-break: break-all;
`;

export const Wrapper = styled('div')`
    display: flex;
    padding: 19px;
    gap: 12px;
    border-radius: 20px;
    border: 1px solid ${COLORS.neutral_05};
    background-color: ${COLORS.neutral_00};
    ${baseShadowStyle};
    cursor: pointer;

    &:hover ${Controls} {
        visibility: visible;
        opacity: 1;
    }

    &:hover ${Title} {
        & > :first-child {
            color: ${COLORS.primary_60};
        }
    }
`;

export const Content = styled('div')`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: 8px;
`;

export const ProductCount = styled('div')`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 16px;
    height: 24px;
    background-color: ${COLORS.neutral_05};
    padding: 4px 8px;
`;

export const Description = styled(Typography)`
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const StyledLink = styled(LinkScroll)`
    display: contents;
`;
